// My Fleet — Business rules helpers (ported from mobile app)

export const RULES_LABELS = {
  vidange: "Vidange",
  pneus: "Pneus",
  freins: "Freins",
  batterie: "Batterie",
  distribution: "Distribution",
  revision: "Révision",
  assurance: "Assurance",
  controle_technique: "Contrôle technique",
  carte_grise: "Carte grise",
  macaron_vtc: "Macaron VTC",
  autre_document: "Document",
  custom_maintenance: "Entretien",
  autre: "Autre",
};

export const MAINTENANCE_TYPES = [
  "vidange", "pneus", "freins", "batterie", "distribution", "revision",
];

export const DOCUMENT_TYPES = ["assurance", "controle_technique", "carte_grise", "macaron_vtc"];

export const INTERVENTION_TYPES = [
  "vidange", "pneus", "freins", "batterie", "distribution", "revision",
  "assurance", "controle_technique", "macaron_vtc", "carte_grise", "autre",
];

export function statusColors(status) {
  if (status === "urgent") return { bg: "var(--mf-urgent-bg)", text: "var(--mf-urgent-text)", solid: "var(--mf-urgent-solid)" };
  if (status === "upcoming") return { bg: "var(--mf-upcoming-bg)", text: "var(--mf-upcoming-text)", solid: "var(--mf-upcoming-solid)" };
  return { bg: "var(--mf-ok-bg)", text: "var(--mf-ok-text)", solid: "var(--mf-ok-solid)" };
}

export function statusLabel(status) {
  if (status === "urgent") return "Urgent";
  if (status === "upcoming") return "À prévoir";
  return "À jour";
}

export function formatKm(n) {
  if (n === null || n === undefined) return "—";
  return `${Number(n).toLocaleString("fr-FR")} km`;
}

export function formatEuros(n) {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 2 });
}

export function daysUntil(iso) {
  if (!iso) return null;
  try {
    const target = new Date(iso);
    const now = new Date();
    target.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);
    return Math.round((target.getTime() - now.getTime()) / 86400000);
  } catch { return null; }
}

export function humanDelay(iso) {
  const d = daysUntil(iso);
  if (d === null) return null;
  if (d < 0) {
    const past = -d;
    if (past < 30) return `Il y a ${past} j`;
    return `Il y a ${Math.round(past / 30.5)} mois`;
  }
  if (d === 0) return "Aujourd'hui";
  if (d === 1) return "Demain";
  if (d < 30) return `Dans ${d} j`;
  return `Dans ${Math.round(d / 30.5)} mois`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function mapNetworkError(e) {
  if (!e) return "Une erreur est survenue";
  if (e.message === "Network Error") return "Connexion impossible. Vérifiez votre réseau.";
  const status = e?.response?.status;
  if (status === 401 || status === 403) return "Session expirée. Reconnectez-vous.";
  if (status >= 500) return "Serveur momentanément indisponible.";
  return e?.response?.data?.detail || e?.message || "Une erreur est survenue";
}
